if (!customElements.get('td-pdp-add-accessories')) {
  class TdPdpAddAccessories extends HTMLElement {
    constructor() {
      super();
      this.formId = this.getAttribute('form-id');
      this.selected = new Map();
      this.onVariantAdded = this.onVariantAdded.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-td-acc-track]');
      this.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-td-acc-add]');
        if (addButton) return this.onAddClick(addButton);
        const option = event.target.closest('[data-td-acc-option]');
        if (option) return this.onOptionClick(option);
        const confirm = event.target.closest('[data-td-acc-drawer-confirm]');
        if (confirm) return this.onConfirm(confirm.closest('[data-td-acc-drawer]'));
        const remove = event.target.closest('[data-td-acc-drawer-remove]');
        if (remove) return this.onRemove(remove.closest('[data-td-acc-drawer]'));
        const close = event.target.closest('[data-td-acc-drawer-close]');
        if (close) return this.closeDrawer();
        const faqToggle = event.target.closest('[data-faq-toggle]');
        if (faqToggle) return this.onFaqToggle(faqToggle);
      });
      this.initCarousel();
      document.addEventListener('variant:added', this.onVariantAdded);
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:added', this.onVariantAdded);
      document.removeEventListener('keydown', this.onKeyDown);
      if (this.carouselQuery && this.onCarouselQueryChange) this.carouselQuery.removeEventListener('change', this.onCarouselQueryChange);
      if (this.carousel) {
        this.carousel.destroy(true, true);
        this.carousel = null;
      }
    }

    initCarousel() {
      if (!this.track || typeof Swiper === 'undefined') return;
      this.carouselQuery = matchMedia('(max-width: 739px)');
      this.onCarouselQueryChange = () => {
        if (this.carouselQuery.matches && !this.carousel) {
          this.carousel = new Swiper(this.track, {
            slidesPerView: 'auto',
            spaceBetween: 32,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            grabCursor: true,
            longSwipesRatio: 0.15,
            longSwipesMs: 300,
            navigation: {
              prevEl: this.querySelector('[data-td-acc-prev]'),
              nextEl: this.querySelector('[data-td-acc-next]'),
              disabledClass: 'td-pdp-accessories__arrow--disabled'
            },
            scrollbar: {
              el: this.querySelector('[data-td-acc-progress]'),
              draggable: true
            }
          });
        } else if (!this.carouselQuery.matches && this.carousel) {
          this.carousel.destroy(true, true);
          this.carousel = null;
        }
      };
      this.carouselQuery.addEventListener('change', this.onCarouselQueryChange);
      this.onCarouselQueryChange();
    }

    get items() {
      return [...this.querySelectorAll('.td-pdp-accessories__item')];
    }

    cardButton(productId) {
      return this.querySelector(`[data-td-acc-add][data-product-id="${productId}"]`);
    }

    effectivePrice(drawer, cents) {
      const pct = parseInt(drawer.getAttribute('data-pct'), 10) || 0;
      if (drawer.getAttribute('data-eligible') !== 'true' || pct <= 0) return cents;
      return Math.floor((cents * (100 - pct)) / 100);
    }

    formatMoney(cents) {
      const value = cents / 100;
      const amount = Number.isInteger(value) ? value.toString() : value.toFixed(2);
      const format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '${{amount}}';
      return format.replace(/{{\s*amount[^}]*}}/, amount);
    }

    onAddClick(button) {
      const productId = button.getAttribute('data-product-id');
      if (button.getAttribute('data-multi') === 'true') {
        this.openDrawer(productId);
        return;
      }
      if (this.selected.has(productId)) {
        this.selected.delete(productId);
        this.markCard(productId, false);
      } else {
        this.selected.set(productId, {
          variantId: parseInt(button.getAttribute('data-variant-id'), 10),
          cents: parseInt(button.getAttribute('data-price'), 10) || 0
        });
        this.markCard(productId, true);
      }
      this.notifyChange();
    }

    markCard(productId, active) {
      const button = this.cardButton(productId);
      if (!button) return;
      button.classList.toggle('td-pdp-accessories__add--selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    openDrawer(productId) {
      this.closeDrawer();
      const drawer = this.querySelector(`[data-td-acc-drawer="${productId}"]`);
      if (!drawer) return;
      if (!drawer.tdVariants) {
        const data = drawer.querySelector('[data-td-acc-drawer-variants]');
        drawer.tdVariants = data ? JSON.parse(data.textContent) : [];
        const imageMap = drawer.querySelector('[data-td-acc-drawer-image-map]');
        drawer.tdImageMap = imageMap ? JSON.parse(imageMap.textContent) : {};
        const galleries = drawer.querySelector('[data-td-acc-drawer-variant-galleries]');
        drawer.tdVariantGalleries = galleries ? JSON.parse(galleries.textContent) : [];
      }
      const current = this.selected.get(productId);
      const preset = current
        ? drawer.tdVariants.find((v) => v.id === current.variantId)
        : drawer.tdVariants[0];
      drawer.querySelectorAll('[data-td-acc-option]').forEach((option) => option.classList.remove('fsb-modal-variant-option--selected'));
      if (preset) {
        preset.options.forEach((value, index) => {
          drawer.querySelectorAll(`[data-td-acc-option][data-position="${index + 1}"]`).forEach((option) => {
            if (option.getAttribute('data-value') === value) option.classList.add('fsb-modal-variant-option--selected');
          });
        });
      }
      drawer.querySelector('[data-td-acc-drawer-remove]').hidden = !current;
      this.syncDrawer(drawer);
      this.openedDrawer = drawer;
      drawer.classList.add('fsb-whats-in-box__modal--open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => this.initDrawerSwiper(drawer), 50);
    }

    closeDrawer() {
      if (!this.openedDrawer) return;
      this.openedDrawer.classList.remove('fsb-whats-in-box__modal--open');
      this.openedDrawer = null;
      document.body.style.overflow = '';
    }

    onKeyDown(event) {
      if (event.key === 'Escape') this.closeDrawer();
    }

    onFaqToggle(toggle) {
      const drawer = toggle.closest('[data-td-acc-drawer]');
      if (!drawer) return;
      const index = toggle.getAttribute('data-faq-toggle');
      const content = drawer.querySelector(`[data-faq-content="${index}"]`);
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (content) content.classList.toggle('fsb-whats-in-box__modal-faq-content--open', !isOpen);
    }

    initDrawerSwiper(drawer, gallerySet = null) {
      if (typeof Swiper === 'undefined') return;
      const activeGallerySet = gallerySet || drawer.querySelector('[data-gallery-set]:not([hidden])');
      if (!activeGallerySet) return;
      const mainSwiperEl = activeGallerySet.querySelector('.fsb-whats-in-box__modal-swiper');
      const thumbsSwiperEl = activeGallerySet.querySelector('.fsb-whats-in-box__modal-thumbs');
      if (!mainSwiperEl) return;
      if (mainSwiperEl.swiper) {
        mainSwiperEl.swiper.update();
        if (thumbsSwiperEl && thumbsSwiperEl.swiper) thumbsSwiperEl.swiper.update();
        return;
      }
      const slideCount = mainSwiperEl.querySelectorAll('.swiper-slide').length;
      let thumbsSwiper = null;
      if (slideCount > 1 && thumbsSwiperEl) {
        thumbsSwiper = new Swiper(thumbsSwiperEl, {
          spaceBetween: 10,
          slidesPerView: 4.4,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              slidesPerView: 5.4
            }
          }
        });
      }
      const mainSwiper = new Swiper(mainSwiperEl, {
        spaceBetween: 10,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
      });
      if (thumbsSwiper) {
        const followActive = () => {
          const index = Math.max(0, mainSwiper.activeIndex - 1);
          const slideSize = (thumbsSwiper.slidesSizesGrid[0] || 0) + thumbsSwiper.params.spaceBetween;
          const target = Math.max(thumbsSwiper.maxTranslate(), Math.min(0, -(index * slideSize) + slideSize * 0.5));
          thumbsSwiper.translateTo(target, 300);
        };
        mainSwiper.on('slideChange', followActive);
        followActive();
      }
    }

    updateDrawerGallery(drawer, variantId) {
      const hasCustomGallery = drawer.tdVariantGalleries && drawer.tdVariantGalleries.includes(variantId);
      drawer.querySelectorAll('[data-gallery-set]').forEach((set) => { set.hidden = true; });
      if (hasCustomGallery) {
        const variantGallery = drawer.querySelector(`[data-gallery-set="${variantId}"]`);
        if (variantGallery) {
          variantGallery.hidden = false;
          this.initDrawerSwiper(drawer, variantGallery);
        }
        return;
      }
      const defaultGallery = drawer.querySelector('[data-gallery-set="default"]');
      if (defaultGallery) {
        defaultGallery.hidden = false;
        this.initDrawerSwiper(drawer, defaultGallery);
        setTimeout(() => {
          const imageIndex = drawer.tdImageMap ? drawer.tdImageMap[String(variantId)] : undefined;
          const mainSwiperEl = defaultGallery.querySelector('.fsb-whats-in-box__modal-swiper');
          if (imageIndex !== undefined && imageIndex !== null && mainSwiperEl && mainSwiperEl.swiper) {
            mainSwiperEl.swiper.slideTo(imageIndex);
          }
        }, 100);
      }
    }

    onOptionClick(option) {
      const drawer = option.closest('[data-td-acc-drawer]');
      const selector = option.closest('.fsb-modal-variant-selector__options');
      selector.querySelectorAll('[data-td-acc-option]').forEach((el) => el.classList.remove('fsb-modal-variant-option--selected'));
      option.classList.add('fsb-modal-variant-option--selected');
      this.syncDrawer(drawer);
    }

    drawerSelection(drawer) {
      const values = [];
      drawer.querySelectorAll('.fsb-modal-variant-selector').forEach((selector) => {
        const active = selector.querySelector('.fsb-modal-variant-option--selected');
        values.push(active ? active.getAttribute('data-value') : null);
      });
      return values;
    }

    resolveVariant(drawer) {
      const values = this.drawerSelection(drawer);
      if (values.some((value) => value === null)) return null;
      return drawer.tdVariants.find((variant) => variant.options.every((option, index) => option === values[index])) || null;
    }

    syncDrawer(drawer) {
      const values = this.drawerSelection(drawer);
      drawer.querySelectorAll('.fsb-modal-variant-selector').forEach((selector, index) => {
        const label = selector.querySelector('[data-td-acc-option-value]');
        const name = selector.querySelector('.fsb-modal-variant-selector__name').textContent.replace(':', '');
        if (label) label.textContent = values[index] || `Select ${name}`;
      });
      const variant = this.resolveVariant(drawer);
      const confirm = drawer.querySelector('[data-td-acc-drawer-confirm]');
      confirm.disabled = !variant;
      const priceEl = drawer.querySelector('[data-td-acc-drawer-price]');
      const compareEl = drawer.querySelector('[data-td-acc-drawer-compare]');
      const reference = variant || drawer.tdVariants[0];
      if (reference) {
        const effective = this.effectivePrice(drawer, reference.cents);
        priceEl.textContent = this.formatMoney(effective);
        if (effective !== reference.cents) {
          compareEl.textContent = this.formatMoney(reference.cents);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
      if (variant) this.updateDrawerGallery(drawer, variant.id);
    }

    cardItem(productId) {
      const button = this.cardButton(productId);
      return button ? button.closest('.td-pdp-accessories__item') : null;
    }

    updateCardForVariant(productId, variant, cents) {
      const item = this.cardItem(productId);
      if (!item) return;
      const img = item.querySelector('.td-pdp-accessories__image img');
      const current = item.querySelector('[data-td-acc-price-current]');
      const compare = item.querySelector('[data-td-acc-price-compare]');
      if (!item.tdDefaults) {
        item.tdDefaults = {
          src: img ? img.getAttribute('src') : null,
          srcset: img ? img.getAttribute('srcset') : null,
          price: current ? current.textContent : null,
          compare: compare ? compare.textContent : null
        };
      }
      if (img && variant.image) {
        img.removeAttribute('srcset');
        img.setAttribute('src', variant.image);
      }
      if (current) current.textContent = this.formatMoney(cents);
      if (compare) compare.textContent = this.formatMoney(variant.cents);
    }

    restoreCard(productId) {
      const item = this.cardItem(productId);
      if (!item || !item.tdDefaults) return;
      const defaults = item.tdDefaults;
      const img = item.querySelector('.td-pdp-accessories__image img');
      if (img && defaults.src) {
        img.setAttribute('src', defaults.src);
        if (defaults.srcset) img.setAttribute('srcset', defaults.srcset);
      }
      const current = item.querySelector('[data-td-acc-price-current]');
      const compare = item.querySelector('[data-td-acc-price-compare]');
      if (current && defaults.price != null) current.textContent = defaults.price;
      if (compare && defaults.compare != null) compare.textContent = defaults.compare;
    }

    onConfirm(drawer) {
      const variant = this.resolveVariant(drawer);
      if (!variant) return;
      const productId = drawer.getAttribute('data-td-acc-drawer');
      const cents = this.effectivePrice(drawer, variant.cents);
      this.selected.set(productId, { variantId: variant.id, cents });
      this.markCard(productId, true);
      this.updateCardForVariant(productId, variant, cents);
      this.notifyChange();
      this.closeDrawer();
    }

    onRemove(drawer) {
      const productId = drawer.getAttribute('data-td-acc-drawer');
      this.selected.delete(productId);
      this.markCard(productId, false);
      this.restoreCard(productId);
      this.notifyChange();
      this.closeDrawer();
    }

    notifyChange() {
      let total = 0;
      this.selected.forEach((entry) => { total += entry.cents; });
      document.dispatchEvent(new CustomEvent('td-accessories:changed', {
        detail: { formId: this.formId, total }
      }));
    }

    async onVariantAdded(event) {
      if (this.adding) return;
      const target = event.target;
      if (!target || !target.getAttribute || target.getAttribute('id') !== this.formId) return;
      if (!this.selected.size) return;
      this.adding = true;
      try {
        const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [...this.selected.values()].map((entry) => ({ id: entry.variantId, quantity: 1 })),
            sections: 'mini-cart'
          })
        });
        if (!response.ok) return;
        const responseJson = await response.json();
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (cartResponse) => {
          const cartContent = await cartResponse.json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cartContent }
          }));
        });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: responseJson, openMiniCart: false }
        }));
        [...this.selected.keys()].forEach((productId) => this.restoreCard(productId));
        this.selected.clear();
        this.querySelectorAll('[data-td-acc-add]').forEach((button) => {
          button.classList.remove('td-pdp-accessories__add--selected');
          button.setAttribute('aria-pressed', 'false');
        });
        this.notifyChange();
      } finally {
        this.adding = false;
      }
    }
  }
  customElements.define('td-pdp-add-accessories', TdPdpAddAccessories);
}
